export const SUPPORT_CHUNK = 'Support';

/** WS-событие с новым сообщением переписки с поддержкой */
export const SUPPORT_MESSAGE_WS_EVENT = 'OnSupportMessage';
